/**
 * useAiAssistant — Marketing AI yordamchisi (context-aware) uchun global store.
 *
 * Sahifalar shu store orqali AI panelni ochadi va KONTEKST beradi (dashboard
 * raqamlari, kampaniya, kreativ). AI panel (AiPanel/AiChatBar) shu store'ni
 * o'qib, kontekstga qarab backend `/api/marketing/ai/*` endpointlariga so'rov
 * yuboradi.
 *
 * KONTRAKT (barqaror — nomlar/signaturalar o'zgartirilmaydi; AiChat agenti
 * faqat panel + backend ulashni to'ldiradi):
 *   openChat(ctx?)            — panelni ochadi (ixtiyoriy kontekst bilan)
 *   analyzeCreative(id, ctx?) — kreativni AI bilan tahlil (video/senariy baho)
 *   summarizeDashboard(data)  — joriy dashboard raqamlari xulosasi
 *   summarizeCampaign(id,d?)  — kampaniya xulosasi
 *   close()                   — panelni yopadi
 */
import { create } from "zustand";

export type AiPage =
  | "dashboard"
  | "campaign"
  | "creative"
  | "scenario"
  | "generic";

export interface AiContext {
  page: AiPage;
  title?: string;
  /** Sahifa konteksti — raqamlar yoki entity (backendga yuboriladi). */
  data?: unknown;
  /** Ochilganda avtomatik yuboriladigan boshlang'ich savol/buyruq. */
  autoPrompt?: string;
}

interface AiAssistantState {
  open: boolean;
  context: AiContext | null;
  openChat: (ctx?: AiContext) => void;
  analyzeCreative: (creativeId: string, ctx?: Partial<AiContext>) => void;
  summarizeDashboard: (data: unknown) => void;
  summarizeCampaign: (campaignId: string, data?: unknown) => void;
  close: () => void;
}

export const useAiAssistant = create<AiAssistantState>((set) => ({
  open: false,
  context: null,
  openChat: (ctx) => set({ open: true, context: ctx ?? { page: "generic" } }),
  analyzeCreative: (creativeId, ctx) =>
    set({
      open: true,
      context: {
        page: "creative",
        data: { creativeId },
        autoPrompt:
          "Ushbu kreativ (video + senariy matni)ni to'liq tahlil qil, baho ber va yaxshiroq senariylar taklif et.",
        ...ctx,
      },
    }),
  summarizeDashboard: (data) =>
    set({
      open: true,
      context: {
        page: "dashboard",
        data,
        autoPrompt:
          "Ushbu davr ko'rsatkichlarini tahlil qil: nega lid kam/ko'p, qayerda xato, qayerda ustunlik, ads'ni qanday yaxshilash mumkin.",
      },
    }),
  summarizeCampaign: (campaignId, data) =>
    set({
      open: true,
      context: {
        page: "campaign",
        data: { campaignId, payload: data },
        autoPrompt: "Ushbu kampaniya natijalarini tahlil qil va xulosa ber.",
      },
    }),
  close: () => set({ open: false }),
}));
